(function(){
var $=function(s,r){return (r||document).querySelector(s)};
var burger=$('#burger'),nav=$('#nav');
if(burger)burger.addEventListener('click',function(){var o=nav.classList.toggle('open');burger.setAttribute('aria-expanded',o)});
document.querySelectorAll('nav>ul>li>a[aria-haspopup]').forEach(function(a){a.addEventListener('click',function(e){if(innerWidth<=900){e.preventDefault();a.parentNode.classList.toggle('show')}})});
var sort=$('#sort');
if(sort)sort.addEventListener('change',function(){var u=new URL(location.href);u.searchParams.set('sort_by',sort.value);u.searchParams.delete('page');location.href=u});
var p=$('[data-product]');if(!p)return;
var V=JSON.parse($('#variants-json').textContent),vid=$('#vid'),price=$('#price'),atc=$('#atc'),gal=$('#gal');
var T={add:atc.dataset.add||'Add to cart',sold:atc.dataset.sold||'Sold out',na:atc.dataset.na||'Unavailable'};
var lastMedia=null;
function show(id){
  var el=document.getElementById('m'+id);if(!el||!gal)return;
  if(innerWidth<=900){gal.scrollTo({left:el.offsetLeft-gal.offsetLeft,behavior:'smooth'})}
  else{el.scrollIntoView({behavior:'smooth',block:'start'})}
}
function update(){
  var vals=[];
  p.querySelectorAll('[data-opt]').forEach(function(g){var c=g.querySelector('input:checked');vals[+g.dataset.opt]=c?c.value:null;if(c)g.previousElementSibling.querySelector('span').textContent=c.value});
  var v=V.find(function(x){return x.options.every(function(o,i){return o===vals[i]})});
  if(!v){atc.disabled=true;atc.textContent=T.na;return}
  vid.value=v.id;price.innerHTML=(v.cmp>v.pr?'<s>'+v.compare+'</s> ':'')+v.price;
  atc.disabled=!v.available;atc.textContent=v.available?T.add:T.sold;
  if(v.media&&v.media!==lastMedia){lastMedia=v.media;show(v.media)}
  history.replaceState(null,'','?variant='+v.id);
}
p.querySelectorAll('[data-opt] input').forEach(function(i){i.addEventListener('change',update)});
})();